import { OilBlockDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OilBlockService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getOilBlock(): Observable<OilBlockDto[]> {
    return this.http.get<OilBlockDto[]>(this.url + 'oil-block');
  }

  createOilBlock(data: OilBlockDto[]): Observable<OilBlockDto[]> {
    return this.http.post<OilBlockDto[]>(this.url + 'oil-block', data);
  }
  getSingleOilBlock(id: string): Observable<any> {
    return this.http.get(this.url + 'oil-block/' + id);
  }

  updateOilBlock(data: OilBlockDto[]): Observable<OilBlockDto[]> {
    return this.http.post<OilBlockDto[]>(this.url + 'oil-block/update', data);
  }

  deleteOilBlock(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('oil-block', ids.join(', '));
    return this.http.delete(this.url + 'oil-block', httpOptions);
  }
}
